<iu-monaco-editor
  [heightOptions]="{ value: '900px' }"
  [language]="'xml'"
  [readonly]="true"
  (editorDestroy)="onEditorDestroy($event)"
  (editorReady)="onEditorReady($event)" />
